import React from "react";
import styled from "@emotion/styled";
import purify from "dompurify";
export default function PlainText(props) {
  return <>{purify.sanitize(props?.Copy)}</>;
}
